(function () {
    "use strict";
    angular.module('angular.emlpayments')
            .constant("SF_EVENTS", {
                "CARDSWIPE_SUCCESS": "sf-cardSwipe-success"
            })


    ;
}());